import type { DateTime } from 'luxon';

export interface BookingPayment {
	id: string;
	bookingId: string;
	amount: number;
	createdAt: DateTime;
	updatedAt: DateTime;
	status: BookingPaymentStatus;
	method: BookingPaymentMethod;
	fee: number;
	amountRefunded: number;
	objectId?: string;
	errorCode?: string;
}

export enum BookingPaymentMethod {
	ONLINE = 'online',
	POS = 'pos',
	GIFTCARD = 'giftcard',
	GUARANTEE = 'guarantee'
}

export enum BookingPaymentStatus {
	PROCESSING = 'processing',
	SUCCESS = 'success',
	FAILED = 'failed',
	CANCELED = 'canceled',
	REFUNDED = 'refunded'
}
